import { Tab, Tabs } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const RiderTabs = styled(Tabs)`
  pointer-events: all;
  & .MuiTabs-flexContainer {
    gap: 16px;
  }
  & .MuiTab-root {
    display: flex;
    flex-direction: row;
    padding: 2px 8px;
    height: 45px;
    min-height: 33px;
    border-radius: 24px;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;

    .MuiTab-iconWrapper {
      margin-bottom: 0;
    }
  }
`;

export const RiderTab = styled(Tab)`
  border: 1px solid ${colorTokens.primary.outlineBorder};
`;
export const RemovedRiderTab = styled(Tab)`
  color: ${colorTokens.text.secondary};
  border: 1px solid ${colorTokens.border.main};
  text-decoration: line-through;
  background: ${colorPalette.neutral550};
`;
export const RiderAssistantTab = styled(Tab)`
  color: ${colorTokens.plum.dark};
  border: 1px solid ${colorTokens.plum.outlineBorder};
  background: ${colorPalette.plum950};

  &:hover {
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
    background-color: ${colorPalette.plum995};
  }
  &.Mui-selected {
    background-color: ${colorPalette.plum200};
    color: ${colorTokens.text.contrast};
    border: 1px solid ${colorPalette.plum550};
  }
`;

export const AvatarContainer = styled.div`
  min-width: 33px;
  min-height: 33px;
  background-color: ${colorTokens.text.disabled};
  text-align: center;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid ${colorTokens.text.contrast};

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${colorTokens.text.contrast};
  }
`;
